import React, { useState } from "react";
import styled from "styled-components";
import { Data } from "../Data";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
import { IoMdClose, IoIosMenu } from "react-icons/io";
import { motion } from "framer-motion";

const StyledNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 12vh;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 20px #333;

  @media (max-width: 992px) {
    align-items: flex-start;
    flex-direction: column;
  }
  img {
    max-height: 3rem;
    margin: auto 6rem;
    margin-left: 15vw;
    @media (max-width: 992px) {
      padding: 0.5rem 3rem;
      margin-right: auto;
      margin-left: 0;
    }
  }
`;

const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  margin-left: auto;
  padding: 0;
  display: flex;
  margin-right: 15vw;
  @media (max-width: 992px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    flex-direction: column;
    padding-top: 3vh;
    margin-right: 2rem;
    padding-bottom: 3vh;
  }
`;

const StyledListItem = styled.li`
  margin-left: 6rem;
  border-bottom: 1px solid transparent;
  transition: border-bottom 1000ms;
  position: relative;
  @media (max-width: 992px) {
    margin: 1.5rem 0;
  }
  .underline {
    color: lightgray;
    background: rgba(255, 255, 255, 0.1);
    transition: border-bottom 100ms;
    width: 140%;
    height: 140%;
    z-index: 5;
    position: absolute;
    border-radius: 5px;
    bottom: -20%;
    left: -20%;
  }
`;

const StyledLink = styled(ScrollLink)`
  text-decoration: none;
  color: white;
  cursor: pointer;
  z-index: 15;
`;

const Hamburger = styled.div`
  display: none;
  @media (max-width: 992px) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 3rem;
    top: 0.5rem;
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
`;

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState("");
  const [scrollIndex, setScrollIndex] = useState("");

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const data = Data;
  return (
    <StyledNav onMouseLeave={() => setIndex(scrollIndex)}>
      <Link
        to="/"
        smooth={true}
        duration={500}
      >
        <img
          src={data.companyLogo}
          alt={data.companyName}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        />
      </Link>
      <Hamburger onClick={toggleMenu}>
        {isOpen ? (
          <IoMdClose
            size={50}
            color="#fff"
          />
        ) : (
          <IoIosMenu
            size={50}
            color="#fff"
          />
        )}
      </Hamburger>
      <StyledList isOpen={isOpen}>
        <StyledListItem>
          <StyledLink
            to="home"
            smooth={true}
            duration={500}
            spy={true}
            onSetActive={() => setScrollIndex("home")}
            onClick={() => setIsOpen(false)}
            onMouseEnter={() => setIndex("home")}
          >
            Accueil
            {(index === "home" || scrollIndex === "home") && (
              <motion.div
                className="underline"
                layoutId="underline"
              />
            )}
          </StyledLink>
        </StyledListItem>
        <StyledListItem>
          <StyledLink
            to="about"
            smooth={true}
            duration={500}
            spy={true}
            onSetActive={() => setScrollIndex("about")}
            onClick={() => setIsOpen(false)}
            onMouseEnter={() => setIndex("about")}
          >
            {data.navTitle}
            {(index === "about" || scrollIndex === "about") && (
              <motion.div
                className="underline"
                layoutId="underline"
              />
            )}
          </StyledLink>
        </StyledListItem>
        <StyledListItem>
          <StyledLink
            to="contact"
            smooth={true}
            duration={500}
            spy={true}
            onSetActive={() => setScrollIndex("contact")}
            onClick={() => setIsOpen(false)}
            onMouseEnter={() => setIndex("contact")}
          >
            Contact
            {(index === "contact" || scrollIndex === "contact") && (
              <motion.div
                className="underline"
                layoutId="underline"
              />
            )}
          </StyledLink>
        </StyledListItem>
      </StyledList>
    </StyledNav>
  );
};

export default NavBar;
